import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import TesterBudNavbar from '../subComponent/TesterBudNavBar.js';



import HeroImage from './icons/hero.jpeg'; // Assuming you have a hero image
import VarietyIcon from './icons/form-icon.png'; // Placeholder for icons
import RealisticIcon from './icons/e-commerce-shopping-website-icon.png';
import ApiIcon from './icons/software-program-icon.png';
import FocusedIcon from './icons/website-ui-icon.png';






const HomePage = () => {
  return (
    <HelmetProvider>
      <Helmet>
        <title>TesterBud - Best Demo Website for Automation Testing | Practice & Learn</title>
        <meta http-equiv="Content-type" content="text/html;charset=UTF-8"></meta>
        <meta
          name="description"
          content="Master automation testing with TesterBud! Access free demo websites for Selenium, Cypress, TestNG & more. Practice login forms, e-commerce flows, and UI automation. Start your journey today!"
        />
        <meta
          name="keywords"
          content="Demo website for automation testing, Demo website for testing, Demo website for selenium testing, Demo website for manual testing, Demo website for Cypress testing, Demo website for Selenium testing, Free demo website for testing, Free demo website for automation testing, Dummy website for testing, Dummy website for automation testing, Dummy website for selenium testing, Dummy website for manual testing, Dummy website for login testing, Sample website for automation testing, Sample website for testing, Sample login website for testing, Sample website for Selenium automation testing, Sample eCommerce website for automation testing, Demo e-commerce website for testing, Demo e-commerce website for automation testing, Demo eCommerce website for testing, Demo shopping website for automation testing, E-commerce website for testing, E-commerce website for testing practice, E-commerce demo website for testing, E-commerce website for automation testing, Automation testing for eCommerce website, Website for automation testing, Website for automation testing practice, Testing website for automation, Best website for automation testing, Simple website for automation testing, Free website for automation testing, Practice website for Selenium automation testing, Dummy website for login testing, Fake login website for testing, Login website for testing, Website for testing, Website for testing Selenium"
        />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="TesterBud Team" />
        <meta property="og:title" content="TesterBud - Best Demo Website for Automation Testing | Practice & Learn" />
        <meta
          property="og:description"
          content="Master automation testing with TesterBud! Access free demo websites for Selenium, Cypress, JMeter & more. Practice login forms, e-commerce flows, and UI automation. Start your journey today!"
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://testerbud.com/" />
        <meta name="geo.region" content="GLOBAL" />
        <meta name="geo.placename" content="Global" />
      </Helmet>
      <div className="home-page">
        <Container fluid className="hero-section bg-primary text-white py-5" style={{ position: 'relative', overflow: 'hidden' }}>
          <Row className="align-items-center justify-content-center">
            <Col md={6} className="text-center text-md-start">
           
              <h3 className="display-4 fw-bold mb-3">TesterBud – The Ultimate Automation Playground</h3>
              <p className="lead mb-2">
                TesterBud – The Ultimate Playground for Automation Testers! 🚀 Practice XPath, UI automation, and real-world testing challenges with interactive dummy sites.
              </p>
              <Button
                as={Link}
                to="/practice-page-selection"
                variant="warning"
                size="md"
                className="fw-bold text-dark border-0 shadow-sm"
                style={{
                  padding: "24px 36px",
                  borderRadius: "20px",
                  transition: "all 0.3s ease-in-out"
                }}
              >
                Get Started ➜
              </Button>

            </Col>
            <Col md={5} className="d-none d-md-block text-center">
              {/* Replace with your actual hero image component or import */}
              <div style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-start' }}>
                <div
                  style={{
                    width: '60%', // Adjust the size of the circular area
                    height: '60%', // Ensure width and height are equal for a perfect circle
                    borderRadius: '70%', // This creates the circular shape
                    overflow: 'auto', // Clips the image to the circle
                    marginTop: '-4%',
                    marginRight: '10%',
                    marginBottom:'-4%',
                  }}
                >
                  <img src={HeroImage} alt="Automation Illustration" className="img-fluid" style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain', // Or 'cover' depending on desired behavior
                  }} />
                </div>
              </div>
            </Col>
          </Row>
        </Container>
        <TesterBudNavbar/>

        <Container fluid className="features-section py-4 text-center bg-light">
          <h2 className="fw-bold text-dark">Features</h2>
          <p className="lead text-dark mb-4">
            Your free demo website for testing automation workflows, Dummy e-commerce site, Dummy Flight Booking application, Dummy login forms, and UI interactions.
          </p>
          <Row className="justify-content-center">
            <Col md={3} sm={6} className="mb-4 d-flex">
              <div className="feature-card shadow-sm bg-white rounded p-3 h-100 d-flex flex-column">
                <Link to="/practice-page-selection" className="text-decoration-none text-primary fw-bold">
                <img src={VarietyIcon} alt="Variety of Demo Sites" className="feature-icon mb-3 mx-auto d-block" style={{ maxWidth: '50px' }} />
                <h3 className="h6 fw-bold text-dark">Variety of Dummy Sites</h3>
                <p className="small text-secondary flex-grow-1">Explore various dummy sites, including login pages, e-commerce, and flight booking, designed for hands-on automation testing and XPath practice.</p>
                </Link>
              </div>
            </Col>
            <Col md={3} sm={6} className="mb-4 d-flex">
              <div className="feature-card shadow-sm bg-white rounded p-3 h-100 d-flex flex-column">
              <Link to="/practice-page-selection" className="text-decoration-none text-primary fw-bold">
                <img src={RealisticIcon} alt="Realistic Scenarios" className="feature-icon mb-3 mx-auto d-block" style={{ maxWidth: '50px' }} />
                <h3 className="h6 fw-bold text-dark">Realistic Scenarios</h3>
                <p className="small text-secondary flex-grow-1">Practice automation testing with real-world UI elements, login pages, e-commerce, flight booking, and interactive XPath challenges in a live sandbox.</p>
                </Link>
              </div>
            </Col>
            <Col md={3} sm={6} className="mb-4 d-flex">
              <div className="feature-card shadow-sm bg-white rounded p-3 h-100 d-flex flex-column">
              <Link to="/practice-page-selection" className="text-decoration-none text-primary fw-bold">
                <img src={FocusedIcon} alt="Demo APIs" className="feature-icon mb-3 mx-auto d-block" style={{ maxWidth: '50px' }} />
                <h3 className="h6 fw-bold text-dark">Interactive UI Elements</h3>
                <p className="small text-secondary flex-grow-1">Explore a wide range of UI elements, from basic to advanced, to learn, interact, and challenge yourself in finding XPath and automating interactions.</p>
                </Link>
              </div>
            </Col>
            <Col md={3} sm={6} className="mb-4 d-flex">
              <div className="feature-card shadow-sm bg-white rounded p-3 h-100 d-flex flex-column">
              <Link to="/practice-page-selection" className="text-decoration-none text-primary fw-bold">
                <img src={ApiIcon} alt="Focused Practice" className="feature-icon mb-3 mx-auto d-block" style={{ maxWidth: '50px' }} />
                <h3 className="h6 fw-bold text-dark">Comprehensive Form Validation</h3>
                <p className="small text-secondary flex-grow-1">Test and automate form interactions with real-time inline error messages, covering input fields, validation rules, and edge cases.</p>
                </Link>
              </div>
            </Col>
          </Row>
        </Container>

        <Container fluid className="py-5 text-center bg-light">
          <h2 className="mb-4 fw-bold text-dark">Why TesterBud is the Ideal Platform for Automation Testing Practice</h2>
          <Row className="justify-content-center">
            <Col md={9}>
              <div className="p-4 rounded shadow-sm bg-white">
                <ul className="list-unstyled text-start">
                  <li className="mb-3">
                    <Link to="/practice-login-form" className="text-decoration-none text-primary fw-bold">
                      Practice Login Automation
                    </Link>: Explore our dummy login websites and hone your skills in automating login forms and submission processes. Ideal for Selenium, Cypress, and more.
                  </li>
                  <li className="mb-3">
                    Get hands-on experience in&nbsp;
                    <Link to="/practice-forms" className="text-decoration-none text-primary fw-bold">
                      Web Form Automation Practice
                    </Link>: Learn to automate filling text fields, selecting dropdown options, handling radio buttons, and submitting various web forms.
                  </li>
                  <li className="mb-3">
                    Master&nbsp;
                    <Link to="/practice-ecommerece-website" className="text-decoration-none text-primary fw-bold">
                      E-commerce Automation Testing
                    </Link>: Practice automating shopping cart functionalities, order placement, and product browsing on our realistic demo e-commerce site.
                  </li>
                  <li className="mb-3">
                    Enhance your skills with our&nbsp;
                    <Link to="/flight-booking-scenarios" className="text-decoration-none text-primary fw-bold">
                      Flight Booking Automation Practice
                    </Link>: Navigate multi-step flight booking forms, select travel options, and verify booking confirmations in a simulated real-world scenario.
                  </li>
                  <li className="mb-3">
                    Develop expertise in&nbsp;
                    <Link to="/practice-different-ui-elements" className="text-decoration-none text-primary fw-bold">
                      UI Element Automation Practice
                    </Link>: Explore and automate interactions with buttons, links, dropdowns, text fields, and other common web elements on our dedicated practice website.
                  </li>
                  <li className="mb-3">
                    Become proficient in&nbsp;
                    <Link to="/practice-xpath" className="text-decoration-none text-primary fw-bold">
                      XPath for UI Automation Practice
                    </Link>: Utilize our dedicated iframe website to master XPath selectors for accurately locating and interacting with web elements in your automation scripts.
                  </li>
                </ul>
              </div>
            </Col>
          </Row>
        </Container>

        

       

        <footer className="bg-light py-3 text-center text-muted">

          <Container fluid className="bg-light py-5">
            <Container className="text-center ">
              <h2>About TesterBud</h2>
              <p className="lead text-muted mb-4">Your premier destination for mastering automation and testing skills.</p>

              <p className="text-start">
                Welcome to TesterBud, your premier destination for mastering automation and testing skills. In today's
                fast-paced tech environment, proficiency in automation testing is not just an advantage—it's a necessity. We
                understand the challenges faced by aspiring QA professionals and have designed TesterBud to bridge the gap
                between theoretical knowledge and practical application.
              </p>
              <p className="text-start">
                Our platform offers a comprehensive suite of resources, including a robust{' '}
                <Link to="/" style={{ color: '#007bff' }}>
                  demo website for automation testing
                </Link>
                , enabling you to practice in real-world scenarios without the need for complex setups. Whether you're aiming
                to enhance your Selenium skills with our{' '}
                <Link to="/" style={{ color: '#555555', textDecoration: 'none' }}>
                  demo website for selenium testing
                </Link>{' '}
                or looking to master performance testing with our demo website for JMeter testing, TesterBud provides the
                tools you need.
              </p>
              <p className="text-start">
                For those new to the field, our{' '}
                <Link to="/" style={{ color: '#007bff' }}>
                  demo website for manual testing
                </Link>{' '}
                provides a gentle introduction to fundamental testing concepts. Advanced users can leverage our{' '}
                <Link to="/" style={{ color: '#555555', textDecoration: 'none' }}>
                  demo website for Cypress testing
                </Link>{' '}
                to explore cutting-edge automation frameworks. We believe in democratizing access to quality learning
                resources, which is why we offer a{' '}
                <Link to="/" style={{ color: '#007bff' }}>
                  free demo website for testing
                </Link>
                , allowing you to explore our platform without any financial commitment.
              </p>
              <p className="text-start">
                Our{' '}
                <Link to="/" style={{ color: '#555555', textDecoration: 'none' }}>
                  dummy website for testing
                </Link>{' '}
                is designed to simulate various real-world scenarios, from simple login forms on our{' '}
                <Link to="/practice-login-form" style={{ color: '#007bff' }}>
                  dummy website for login testing
                </Link>{' '}
                to complex e-commerce flows on our{' '}
                <Link to="/practice-ecommerece-website" style={{ color: '#555555', textDecoration: 'none' }}>
                  demo e-commerce website for testing
                </Link>
                . You can use our{' '}
                <Link to="/" style={{ color: '#007bff' }}>
                  dummy website for automation testing
                </Link>{' '}
                to practice your skills in a safe and controlled environment.
              </p>
              <p className="text-start">
                We also provide{' '}
                <Link to="/" style={{ color: '#555555', textDecoration: 'none' }}>
                  sample websites for automation testing
                </Link>
                , giving you a clear understanding of how to approach different testing challenges. Our{' '}
                <Link to="/practice-login-form" style={{ color: '#007bff' }}>
                  sample login website for testing
                </Link>{' '}
                is perfect for honing your skills in handling authentication processes, while our{' '}
                <Link to="/practice-ecommerece-website" style={{ color: '#555555', textDecoration: 'none' }}>
                  sample eCommerce website for automation testing
                </Link>{' '}
                allows you to practice automating complex user flows.
              </p>
              <p className="text-start">
                If you're looking for a{' '}
                <Link to="/flight-booking-scenarios" style={{ color: '#555555', textDecoration: 'none' }}>
                  demo flight booking website for automation testing
                </Link>
                , you'll find our{' '}
                <Link to="/flight-booking-scenarios" style={{ color: '#555555', textDecoration: 'none' }}>
                  flight booking website for testing
                </Link>{' '}
                invaluable. We also offer an{' '}
                <Link to="/flight-booking-scenarios" style={{ color: '#555555', textDecoration: 'none' }}>
                  flight booking demo website for testing
                </Link>
                , designed to provide realistic scenarios for{' '}
                <Link to="/flight-booking-scenarios" style={{ color: '#007bff' }}>
                  automation testing for flight booking websites
                </Link>
                .
              </p>

              <p className="text-start">
                If you're looking for a{' '}
                <Link to="/practice-ecommerece-website" style={{ color: '#555555', textDecoration: 'none' }}>
                  demo shopping website for automation testing
                </Link>
                , you'll find our{' '}
                <Link to="/practice-ecommerece-website" style={{ color: '#007bff' }}>
                  e-commerce website for testing
                </Link>{' '}
                invaluable. We also offer an{' '}
                <Link to="/practice-ecommerece-website" style={{ color: '#555555', textDecoration: 'none' }}>
                  e-commerce demo website for testing
                </Link>
                , designed to provide realistic scenarios for{' '}
                <Link to="/practice-ecommerece-website" style={{ color: '#007bff' }}>
                  automation testing for eCommerce websites
                </Link>
                .
              </p>
              <p className="text-start">
                TesterBud is not just a platform; it's a community. Our{' '}
                <Link to="/" style={{ color: '#555555', textDecoration: 'none' }}>
                  website for automation testing practice
                </Link>{' '}
                is designed to foster collaboration and knowledge sharing. We believe that the{' '}
                <Link to="/" style={{ color: '#007bff' }}>
                  best website for automation testing
                </Link>{' '}
                should be accessible to everyone, which is why we offer a{' '}
                <Link to="/" style={{ color: '#007bff' }}>
                  free website for automation testing
                </Link>
                .
              </p>
              <p className="text-start">
                Our{' '}
                <Link to="/" style={{ color: '#555555', textDecoration: 'none' }}>
                  simple website for automation testing
                </Link>{' '}
                allows you to focus on the core concepts without getting bogged down by unnecessary complexity. If you're
                specifically interested in Selenium, our{' '}
                <Link to="/" style={{ color: '#007bff' }}>
                  practice website for Selenium automation testing
                </Link>{' '}
                is tailored to meet your needs.
              </p>
              <p className="text-start">
                We understand the importance of realistic scenarios, which is why we provide a{' '}
                <Link to="/practice-login-form" style={{ color: '#007bff' }}>
                  fake login website for testing
                </Link>
                . Our{' '}
                <Link to="/practice-login-form" style={{ color: '#007bff' }}>
                  login website for testing
                </Link>{' '}
                is designed to help you master the intricacies of authentication testing.
              </p>
              <p className="text-start">
                Whether you're a beginner or an experienced professional, TesterBud is your go-to{' '}
                <Link to="/" style={{ color: '#007bff' }}>
                  website for testing
                </Link>
                . Our resources are designed to help you excel in your career as a QA professional. We are committed to
                providing you with the tools and knowledge you need to succeed in the dynamic field of software testing.
              </p>
              <p className="text-start">
                TesterBud is more than just a{' '}
                <Link to="/" style={{ color: '#007bff' }}>
                  website for testing Selenium
                </Link>
                ; it's a comprehensive platform for all your testing needs. We are dedicated to providing the highest quality
                resources to help you achieve your career goals.
              </p>
            </Container>
          </Container>








          <Container>
            <p className="mb-0">
              Ready to start automating on a{' '}
              <Link to="/" style={{ color: '#007bff' }}>
                website for testing
              </Link>
              ? Explore, practice, and master!
            </p>
            <p className="mb-0 mt-2">© {new Date().getFullYear()} TesterBud | Built for learners by learners 🚀</p>
          </Container>
        </footer>
      </div>
    </HelmetProvider>
  );
};

export default HomePage;